<template>
  <div class="vx-col doc-upload mb-base" :class="colClass">
    <vx-card class="card-body-pt-small" :class="[{'not-upload': !checkUploadable}]">
      <div slot="no-body">
        <vx-upload
          v-if="checkUploadable"
          class="doc-vs-upload"
          text="Seleccione o arrastre un archivo"
          ref="vsupload"
          :automatic="true"
          :action="uploadAction"
          :alreadyLoaded="fileWasLoaded"
          :fileIsVerified="false"
          :fileIsRejected="false"
          :requiresValidation="false"
          :loadedFileName="loadedFileName"
          fileName="file"
          :data="formData"
          :acceptFileTypes="acceptList"
          :headers="headers"
          :disabled="false"
          @on-invalid-extension="onInvalidExtensionEvent"
          @change="onChangeEvent"
          @on-uploading="onUploadingEvent"
          @on-error="onErrorEvent"
          @on-set-file="onSetFile"
          @on-success="onSuccessEvent"
          @on-delete="onDeleteEvent" />
      </div>
      <div v-if="showAlerts" class="flex justify-between flex-wrap mb-4 small-flex">
        <vs-alert v-if="onError" color="danger" style="height: auto">{{ invalidExtension ? invalidExtensionError : genericError }}</vs-alert>
        <vs-alert v-if="onSuccess" color="success" style="height: auto">
          El archivo ha sido cargado correctamente
        </vs-alert>
      </div>

      <template v-if="!onlyShowInput">
        <h6 class="mb-2">{{ label }}</h6>
        <p class="text-grey small">{{ indicationLabel }}</p>
  
        <div v-if="showResults" class="flex justify-between status-doc mt-2">
          <span v-if="fileWasLoaded" class="flex items-center">
            <feather-icon icon="ClockIcon" svgClasses="h-5 w-5 text-success stroke-current" />
            <span class="ml-2 small"><strong>Estatus:</strong> Cargado </span>
          </span>
        </div>
        <div v-if="isUploading" class="flex justify-between status-doc mt-2">
          <span class="flex items-center">
            <feather-icon icon="LoaderIcon" svgClasses="h-5 w-5 text-warning stroke-current" />
            <span class="ml-2 small"><strong>Cargando...</strong></span>
          </span>
        </div>
  
        <vs-divider></vs-divider>
  
        <template v-if="checkUploadable">
          <vs-button class="small" type="border" color="warning" @click="openFilePrompt">{{ fileWasLoaded ? "Actualizar " : "Seleccionar" }} documento</vs-button>
          <vs-divider></vs-divider>
        </template>
  
        <div v-if="canDownload && fileWasLoaded" class="flex justify-between flex-wrap mb-0 small-flex">
          <vs-button class="mr small" type="border" @click="onViewFileRequest" color="success">Ver</vs-button>
          <vs-button class="small" type="border" color="success" @click="onDownloadFileRequest">Descargar</vs-button>
        </div>
  
        <div v-if="!fileWasLoaded && !onError && checkUploadable" class="flex justify-between flex-wrap mb-0 small-flex">
          <vs-alert color="dark" style="height:auto; min-height:28px"> Pendiente de cargar </vs-alert>
        </div>
      </template>
    </vx-card>

  </div>
</template>

<script>
  import VxUpload from '@upload/VxUpload'
  const qColClass = "xxl:w-1/4 xl:w-1/3 lg:w-1/2 md:w-1/2 sm:w-3/4 w-full";
  const tColClass = "xxl:w-1/3 xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-3/4 w-full";
  const mColClass = "xxl:w-1/2 xl:w-70% lg:w-3/4 md:w-5/6 sm:w-full w-full";
  const fColClass = "w-full"

  export default {
    name: "document-upload-lite",
    props: {
      target_id: { type: [String,Number], default: null },
      disabled: { type: Boolean, default: false },
      name: {type: [String], required: true},
      uploadUrl: {type: [String], required: true},
      uploadType: {type: String},
      promissaryId: {type: [String,Number], default: null},
      viewUrl: {type: [String], required: true},
      downloadUrl: {type: [String], required: true},
      checkUrl: {type: [String], required: true},
      accepts: {type: [Array], default: function () {
          return ['pdf','jpg','png','jpeg'];
        },
      },
      selfAccessToken: { type: String, default: null},
      width: {
        validator: function (){
          return ['1/4','1/3','1/2','1']
        },
        default: '1/3',
      },
      canUpload: { type: Boolean, default: true },
      uploadAll: { type: Boolean, default: false },
      onlyShowInput: { type: Boolean, default: false },
    },
    components: {
      VxUpload
    },
    data(){
      return {
        onFileSelected: false,
        onError: false,
        onSuccess: false,
        fileWasLoaded: false,
        visibleStateLoaded: false,
        invalidExtension: false,

        showInfoPrompt: null,
        isUploading: null,
        loadedFileName: null,

        colClass: null,

        /* mensajes */
        genericError: "Ha ocurrido un error con la carga.",
        invalidExtensionError: "El tipo de archivo seleccionado no es válido, intente con otro archivo.",
        updateError: "Ha ocurrido un error al intentar actualizar",
        remainMssg: "El archivo cargado previamente seguirá activo.",
      }
    },
    computed:{
      showResults(){
        return true;
      },
      isDisabled(){
        return false;
      },
      isVerified(){
        return false;
      },
      isRejected(){
        return false;
      },
      gotVerification(){
        return false;
      },
      preLoaded(){
        return false;
      },
      canDownload(){
        return true;
      },
      hasBackofficeAccess(){
        return this.$acl.check('isBackoffice');
      },
      canViewOperationActions(){
        return false;
      },
      showAlerts(){
        return (this.onSuccess || this.onError);
      },
      acceptList(){
        return this.accepts;
      },
      label(){
        return this.name;
      },
      docName(){
        return this.name
      },
      indicationLabel(){
        return "Documento requerido";
      },
      apiStorageBasePrefix(){
        return this.ApiDomain + "/storagev3/documents/";
      },
      uploadAction (){
        return this.apiStorageBasePrefix + this.uploadUrl + `?uploadAll=${this.uploadAll}&type=${this.uploadType}&promissaryContractId=${this.promissaryId}`;
      },
      formData(){
        return { type: this.uploadType };
      },
      headers(){
        return {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": process.env.VUE_APP_CORS_ALLOW_CREDENTIALS,
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": "Bearer " + this.currentAccessToken,
        };
      },
      accessOnlyByBackoffice(){
        return this.hasBackofficeAccess;
      },
      editableIfBackoffice(){
        return this.hasBackofficeAccess;
      },
      checkUploadable(){
        return this.canUpload;
      },
      assocData(){
        return null;
      },
      currentAccessToken(){
        return this.selfAccessToken !== null ? this.selfAccessToken : this.AccessToken;
      }
    },
    async beforeMount(){
      let c = null;
      switch (this.width){
        case '1':
          c = fColClass;
          break;
        case '1/4':
          c = qColClass;
          break;
        case '1/3':
          c = tColClass;
          break;
        case '1/2':
          c = mColClass;
          break;
        default:
          c = tColClass;
          break;
      }
      this.colClass = c;

      await this.getFileCheck();
    },
    methods: {
      async getFileCheck(){
        let url = this.apiStorageBasePrefix + this.checkUrl + `?type=${this.uploadType}&promissaryContractId=${this.promissaryId}`;
        try {
          let res = await axios.get(url);
          if(res.data.filename){
            this.fileWasLoaded = true;
            this.loadedFileName = res.data.filename;
          } else if (res.data.storage_file) {
            this.fileWasLoaded = true;
            this.loadedFileName = res.data.storage_file;
          }
        }
        catch (error) {
          this.fileWasLoaded = false;
        }
      },
      async saveFile (){
        this.$refs.vsupload.uploadCurrentFile();
      },
      async saveFileWithTarget(target){
        let action = this.customUploadAction(target);
        this.$refs.vsupload.uploadCurrentFileFromParent(action);
      },
      openFilePrompt(){
        this.$refs.vsupload.openFilePrompt();
      },
      onUploadingEvent(){
        this.isUploading = true;
      },
      onSuccessEvent(res){
        let data = JSON.parse(res);
        this.resetFlags();
        this.onSuccess = true;
        this.fileWasLoaded = true;
        this.visibleStateLoaded = true;
        this.empty = false;
        this.$emit("on-success", data);
      },
      onErrorEvent(){
        this.resetFlags();
        this.onError = true;
        this.$emit("on-error");
      },
      onInvalidExtensionEvent(){
        this.resetFlags();
        this.onError = true;
        this.invalidExtension = true;
      },
      onChangeEvent(){
        this.resetFlags();
        this.$emit("on-change", true);
      },
      onDeleteEvent(){
        this.resetFlags();
        this.$emit("on-delete", true);
      },
      onSetFile(){
        // llamado cuando el archivo es cargado en el componente (no es el envío)
        this.prepFileLoaded = true;
      },
      async onViewFileRequest(){
        let url = this.apiStorageBasePrefix + this.viewUrl + `?access_token=${this.currentAccessToken}&type=${this.uploadType}&promissaryContractId=${this.promissaryId}`;
        try {
          //window.open(url, "_blank");
          window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0,height=700,width=800');
        }
        catch (error) {
        }
      },
      onDownloadFileRequest(){
        let url = this.apiStorageBasePrefix + this.downloadUrl + `?access_token=${this.currentAccessToken}&type=${this.uploadType}&promissaryContractId=${this.promissaryId}`;
        try {
          window.open(url, "_blank");
        }
        catch (error) {
        }
      },
      resetFlags(){
        this.onSuccess = false;
        this.onError = false;
        this.invalidExtension = false;
        this.isUploading = false;
      },
      closeRejectPrompt(){
        this.showRejectPrompt = false;
        this.rejection_reason = null;
      },
      showProceessErrorNotif(title, text){
        this.$vs.notify({
          title: title,
          text: text,
          color:'danger',
          iconPack: 'feather',
          position: 'top-center',
          fixed: true,
          icon:'icon-x-circle'
        });
      },
      showProcessSuccessNotif(title, text,){
        this.$vs.notify({
          title: title,
          text: text,
          color:'success',
          iconPack: 'feather',
          position: 'top-center',
          time: '8000',
          icon:'icon-check'
        });
      }
    }
  }
</script>
